export const AUTOCOMPLETE_OPTIONS: google.maps.places.AutocompleteOptions = {
  fields: ['formatted_address', 'geometry', 'name', 'address_components', 'types'],
};

export function extractCountry(addressComponents?: google.maps.GeocoderAddressComponent[]): string {
  const country = addressComponents?.find((comp) => comp.types.includes('country'));
  return country?.short_name ?? '';
}

export function extractCity(addressComponents?: google.maps.GeocoderAddressComponent[]): string {
  const city = addressComponents?.find(
    (comp) =>
      comp.types.includes('locality') ||
      comp.types.includes('postal_town') ||
      comp.types.includes('administrative_area_level_2'),
  );
  return city?.long_name ?? '';
}

export function isPlaceSpecificEnough(place: google.maps.places.PlaceResult | null): boolean {
  if (!place?.types) return false;
  const validTypes = [
    'street_address',
    'route',
    'premise',
    'subpremise',
    'establishment',
    'point_of_interest',
    'airport',
    'transit_station',
    'intersection',
  ];
  return place.types.some((type) => validTypes.includes(type));
}
